export const pollersErrorModalId = 'poller-error-modal';
